import { render, staticRenderFns } from "./AppendixClientAssets.vue?vue&type=template&id=4998e347"
import script from "./AppendixClientAssets.vue?vue&type=script&lang=js"
export * from "./AppendixClientAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports